<template>
  <!-- Login page: full-screen, no sidebar/header -->
  <router-view v-if="isLoginPage" />

  <!-- Authenticated app shell -->
  <div v-else id="layout">
    <Sidebar :class="{ 'mobile-open': mobileMenuOpen }" />

    <!-- Overlay for mobile -->
    <div
      v-if="mobileMenuOpen"
      class="sidebar-overlay"
      @click="mobileMenuOpen = false"
    ></div>

    <div class="app-body">
      <Header @toggle-mobile-menu="mobileMenuOpen = !mobileMenuOpen" />
      <main class="app-main">
        <router-view />
      </main>
    </div>
  </div>
</template>

<script>
import Sidebar from './components/MainSidebar.vue'
import Header from './components/MainHeader.vue'

export default {
  name: 'App',
  components: { Sidebar, Header },
  data() {
    return {
      mobileMenuOpen: false
    }
  },
  computed: {
    isLoginPage() {
      return this.$route.path === '/login'
    }
  },
  watch: {
    '$route'() {
      this.mobileMenuOpen = false
    }
  }
}
</script>

<style>
/* ── Reset ── */
*, *::before, *::after { box-sizing: border-box; }

html, body, #app {
  height: 100%;
  margin: 0;
  font-family: 'Inter', system-ui, -apple-system, sans-serif;
}

body {
  background: var(--bs-body-bg);
  overflow: hidden;
}

/* ── App layout ── */
#layout {
  display: flex;
  flex-direction: row;
  height: 100vh;
  overflow: hidden;
}

.app-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  overflow: hidden;
}

.app-main {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 1.5rem;
  background: var(--bs-body-bg);
  -webkit-overflow-scrolling: touch;
}

/* ── Mobile overlay ── */
.sidebar-overlay {
  display: none;
}

@media (max-width: 767px) {
  #layout {
    position: relative;
  }

  .sidebar-overlay {
    display: block;
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    z-index: 1040;
  }

  .app-main {
    padding: 1rem;
  }
}
</style>
